import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MainService } from '../../provider/main.service';
import { ApiUrls } from '../../config/api-urls/api-urls';
import { Subscription } from 'rxjs';
declare var $: any

@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  showSidebar: boolean = false;
  currentUrl: any;
  profileImage: any;
  profileData: any;
  showLogo: boolean = false;
  userType: string | any;
  permission: any;
  private subscriptions = new Subscription();

  constructor(public mainService: MainService, private router: Router) {
    this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        let userType = localStorage.getItem('userType') ? window.atob(localStorage.getItem('userType') || '') : null;
        this.currentUrl = '/' + e.url.split('/')[1];
        if (this.currentUrl === '/' || this.currentUrl === '/login' || this.currentUrl === '/reset-password' ||
          this.currentUrl === '/otp' || this.currentUrl == '/forgot-password') {
          if (localStorage.getItem('token')) {
            if (userType === 'ADMIN') {
              this.router.navigate(['dashboard'])
            }
          }
        }
      }
    });
  }

  ngOnInit() {
    $('.btn-toggle,.close_panel').click(() => {
      $('body').toggleClass('toggle-wrapper');
    });
    this.mainService.permission.subscribe(res => {
      this.permission = res;
    })
    let userType = localStorage.getItem('userType');
    this.userType = window.atob(userType || '')

    this.mainService.loginData.subscribe((res: any) => {
      if (res) { this.profileData = res }
    });
    this.mainService.loginStatus.subscribe((res: any) => {
      this.showSidebar = res;
    });
    if (localStorage.getItem('token')) {
      this.showSidebar = true;
      this.getProfile();
    }
  }

  // get profile
  getProfile() {
    this.mainService.showSpinner()
    this.mainService.getApi(ApiUrls.profile, 1).subscribe((res: any) => {
      localStorage.setItem('responseCode', res.responseCode);
      this.mainService.isToken.next(res.responseCode)
      if (res.responseCode == 200) {
        this.profileData = res.result;
        this.permission = this.profileData.permissions[0];
        this.mainService.permission.next(this.permission);
        this.mainService.hideSpinner();
      } else {
        this.mainService.hideSpinner();
        if (res.responseCode === 401) {
          this.mainService.errorToast('Your token is expired , please login again.');
          localStorage.removeItem('token');
          localStorage.removeItem('responseCode');
          this.mainService.loginStatus.next(false);
          this.router.navigate(['/login']);
        }
      }
    })
  }

  logOutModal() {
    $('#logoutModal').modal('show')
  }

  logout() {
    this.mainService.loginData.next('');
    this.mainService.loginStatus.next(false)
    localStorage.removeItem('token');
    $('#logoutModal').modal('hide')
    this.router.navigate(['login'])
  }

}
